import { VhButtonPermission } from "vh-button";

// import FileSaver from "file-saver";

/**
 * 是否支持HTML5 history API
 *
 * @returns
 */
export const supportsHistory = () => {
  const ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  };
  return window.history && 'pushState' in window.history;
}

/**
 * 根据名称获取cookie
 *
 * @param {string} name
 * @returns
 */
export const getCookie = (name: string) => {
  let arr;
  const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  }
  else {
  return null;
  }
}

/**
 * 设置cookie
 *
 * @param {string} name cookie名称
 * @param {string} value cookie值
 * @param {date} 过期时间
 * @returns
 */
export const setCookie = (name: string, value: string, date: Date) => {
  if (getCookie(name)) {
    delCookie(name);
  }
  document.cookie = name + "=" + escape (value) + ";expires=" + date.toUTCString();
}

/**
 * 删除cookie
 *
 * @param {string} name cookie名称
 * @returns
 */
export const delCookie = (name: string) => {
  const date = new Date();
  const value = getCookie(name);
  date.setTime(date.getTime() - 1);
  if (value != null) {
    const domain = process.env.REACT_APP_ENV === "dev" ? window.location.hostname : "viphrm.com";
    document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=/;domain=" + domain;
  }
}

/**
 * 对象深拷贝
 *
 * @param {*} obj
 * @returns objCopy
 */
export const deepCopy = (obj: any) => {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * 清除obj中的undefined，null，"", NAN
 *
 * @param {*} obj
 * @returns 清除空值后的对象
 */
export const clearObj = (obj: any) => {
  const o = {...obj};
  for (const key in o) {
    if (o.hasOwnProperty(key) && !o[key] && o[key] !== 0) {
      delete o[key];
    }
  }
  return o;
}

/**
 * 在数组指定位置插入元素
 *
 * @param {*} obj
 * @returns 清除空值后的对象
 */
export const insertArray = (array: any[], index: number, item: any) => {
  array.splice(index, 0, item);
}

/**
 * 在数组指定位置删除元素
 *
 * @param {*} obj
 * @returns 清除空值后的对象
 */
export const deleteArray = (array: any[], index: number) => {
  array.splice(index, 1);
}

/**
 * 将json拼接为请求参数字符串
 *
 * @param {*} params 参数对象
 * @returns 参数字符串
 */
export const appendParams = (url: string, params: any) => {
  if (!url) {
    return "";
  }

  let str = "";
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      str += (key + "=" + params[key] + "&");
    }
  }
  if (str) {
    str = url + "?" + str.substr(0, str.length - 1);
  } else {
    str = url;
  }
  return str;
}

/**
 * 下载文件
 *
 * @param {*} url 文件地址
 */
export const downloadFile = (url: string, fileName?: string) => {
  if (ieVersion() === 9) {
    // ! Not working for json and pdf format !
    const frame = document.createElement("iframe");

    if (frame && frame.contentDocument) {
      document.body.appendChild(frame);
      frame.setAttribute("style", "display:none");
      frame.contentDocument.open("txt/html", "replace");
      frame.contentDocument.write(url); // data 是 string 类型
      frame.contentDocument.close();
      frame.focus();

      frame.contentDocument.execCommand("SaveAs", true, fileName);
      document.body.removeChild(frame);
    }
  } else {
    try {
      // const isFileSaverSupported = !!new Blob;
      // if (!isFileSaverSupported) {
      //   return;
      // }
      // FileSaver.saveAs(url, fileName);

      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";

      // xhr.onprogress = function(event) {
      //     if (event.lengthComputable) {
      //         var percentComplete = (event.loaded / event.total)*100;
      //         //yourShowProgressFunction(percentComplete);
      //     }
      // };

      xhr.onload = function(event) {
        if (this.status == 200) {
          _saveBlob(this.response, fileName || "");
        }
        else {
          console.log(event);
        }
      };

      xhr.onerror = function(event){
        console.log(event);
      };

      xhr.send();


      const _saveBlob = (response: any, fileName: string) => {
        if(navigator.msSaveBlob){
            //OK for IE10+
            navigator.msSaveBlob(response, fileName);
        }
        else{
            _html5Saver(response, fileName);
        }
      }

      const _html5Saver = (blob: any, fileName: string) => {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        document.body.removeChild(a);
      }
    } catch (e) {
      console.log(e);
    }
  }
}

/**
 * 根据名称过滤下拉列表
 *
 * @param {string} name
 * @returns
 */
export const filterOption = (input: string, option: any) => {
  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

/**
 * 获取初始化分页对象
 *
 * @returns 初始化分页对象
 */
export const getInitPagination = () => {
  return {
    pageSize: 25,
    current: 1,
    total: 0,
    totalPages: 0
  };
}

/**
 * 根据键值获取名称
 *
 * @param {any[]} list 列表
 * @param {string} keyValue 键值
 * @param {string | undefined} keyName 键名
 * @param {string | undefined} valueName 值名
 * @returns
 */
export const mappingFilter = (list: any[], keyValue: string | number, keyName?: string, valueName?: string) => {
  if (!list || !list.length) {
    return "";
  }
  const obj = list.find((item: any) => item[(keyName ? keyName : "dataKey")] === keyValue);
  if (obj) {
    return obj[(valueName ? valueName : "dataValue")];
  }
  else {
    return "";
  }
}

/**
 * 事件防抖动事件
 *
 * @param {F} fn type is Arrow Function
 * @param {number} delay
 * @returns
 */
export const debounce = <F extends (...params: any[]) => void>(fn: F, delay: number): F => {
  let timeoutId: number;
  return function(this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => fn.apply(this, args), delay);
  } as F;
}

/**
 * 获取对象数组的每个元素的指定属性值，组成数组返回
 * @param {any[]} array
 * @param {string} key
 * @param {object} filter
 * @return {any[]}
 */
export const arrayPluck = (array: any[], key: string, filter?: {[key: string]: any}) => {
  const rs: any[] = [];

  array.forEach(obj => {
    if (obj[key]) {
      if (filter) {
        const filterKey = Object.keys(filter)[0];
        if (obj[filterKey] === filter[filterKey]) {
          rs.push(obj[key])
        }
      } else {
        rs.push(obj[key])
      }
    }
  });
  return rs;
}

/**
 * 字符串转Date截取保留小时-分-秒
 * @param {string} sourceStr
 * @param {number} start
 * @returns {string}
 */
export const subStrUtil = (sourceStr: string,start :number,end:number)=>{
  if (!sourceStr || !sourceStr.length) {
    return "";
  }else {
    return sourceStr.slice(start,end).toString();
  }
}

/**
  * 字符串转Date然后计算两个日期的时间差
  * @param {string} startTime
  * @param {string} endTime
  * @returns {number}
  */
  export const stringTimeToDate = (startTime:string,endTime:string) => {
  if (!startTime || !startTime.length || !endTime || !endTime.length) {
    return "";
  }
    let begin  : Date ;
    let   end  : Date ;
    let  diff   : number;
    begin = new Date(startTime.replace(/-/g,"/"));
    end = new Date(endTime.replace(/-/g,"/"));
    diff = (end.getTime() - begin.getTime())/(1000*60*60);
  return diff.toFixed(2);
  }

/**
 * 查询按钮是否有权限
 * @param  list  权限列表
 * @param  code  权限的编码
 */
export const getPermission = (list: VhButtonPermission[], code: string) => list.find((ele: VhButtonPermission) => ele.code === code)

/**
 * 获取半角字符长度
 *
 * @returns
 */
export const getLength = (str: string) => {
  return str.replace(/[\u0391-\uFFE5]/g,"aa").length;
}

/**
 * 获取半角字符长度
 *
 * @returns
 */
export const getStrFromLen = (str: string) => {
  let subStr = "";
  let realLength = 0;
  let charCode = -1;
  for (let i = 0; i < str.length; i++) {
    charCode = str.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1;
    } else {
      realLength += 2;
    }
    if (realLength >= 11) {
      subStr = str.substr(0, i + 1);
      break;
    }
  }
  return subStr;
}

/**
 * 浮点数相加
 *
 * @returns number
 */
export const plus = (a: number, b: number) => {
  let c, d, m;

  try {
    c = a.toString().split(".")[1].length;
  } catch(e) {
    c = 0;
  }

  try {
    d = b.toString().split(".")[1].length;
  } catch (e) {
    d = 0;
  }

  m = Math.pow(10, Math.max(c, d));

  return (a * m + b * m) / m;
}

/**
 * 浮点数相减
 *
 * @returns number
 */
export const minus = (a: number, b: number) => {
  let c, d, m;

  try {
    c = a.toString().split(".")[1].length;
  } catch (e) {
    c = 0;
  }

  try {
    d = b.toString().split(".")[1].length;
  } catch (e) {
    d = 0;
  }

  m = Math.pow(10, Math.max(c, d));

  return (a * m - b * m) / m;
}

/**
 * 浮点数相乘
 *
 * @returns number
 */
export const multiply = (a: number, b: number) => {
  let m = 0,
  c = a.toString(),
  d = b.toString();

  try {
      m += c.split(".")[1].length
  } catch(e) {}

  try {
      m += d.split(".")[1].length
  } catch(e) {}

  return Number(c.replace(".", "")) * Number(d.replace(".", "")) / Math.pow(10, m)
}

/**
 * 浮点数相除
 *
 * @returns number
 */
export const division = (a: number, b: number) => {
  let c, d, f, g;

  try {
    c = a.toString().split(".")[1].length;
  } catch (e) {
    c = 0;
  }

  try {
    d = b.toString().split(".")[1].length;
  } catch (e) {
    d = 0;
  }

  f = Number(a.toString().replace(".", ""));
  g = Number(b.toString().replace(".", ""));

  return (f / g) * Math.pow(10, d - c);
}

/**
 * 获取IE浏览器版本
 *
 */
export const ieVersion = () => {
  // 取得浏览器的userAgent字符串
  const userAgent = navigator.userAgent;
  // 判断是否为小于IE11的浏览器
  const isLessIE11 = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
  // 判断是否为IE的Edge浏览器
  const isEdge = userAgent.indexOf('Edge') > -1 && !isLessIE11;
  // 判断是否为IE11浏览器
  const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  if (isLessIE11) {
    const IEReg = new RegExp('MSIE (\\d+\\.\\d+);');
    // 正则表达式匹配浏览器的userAgent字符串中MSIE后的数字部分，，这一步不可省略！！！
    IEReg.test(userAgent);
    // 取正则表达式中第一个小括号里匹配到的值
    const IEVersionNum = parseFloat(RegExp['$1']);
    if (IEVersionNum === 7) {
      // IE7
      return 7
    } else if (IEVersionNum === 8) {
      // IE8
      return 8
    } else if (IEVersionNum === 9) {
      // IE9
      return 9
    } else if (IEVersionNum === 10) {
      // IE10
      return 10
    } else {
      // IE版本<7
      return 6
    }
  } else if (isEdge) {
    // edge
    return 12
  } else if (isIE11) {
    // IE11
    return 11
  } else {
    // 不是ie浏览器
    return -1
  }
}

/**
 * 金额转千分位格式，带两位小数
 * @param  num      金额
 * @param  noFloat  是否要带小数
 * 注：
 * 后端可能会传入已经是千分位的数字，先去掉千分位
 */
export const thousandSeparator = (num: string | number, noFloat?: boolean) => {
  const newNum = `${num}`.replace(/,/g, "");
  if (isNaN(+newNum)) {
    return "";
  }
  const str: any = (+newNum).toFixed(2);
  const arr = str.split(".");
  return `${arr[0].replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}${noFloat ? "" : `.${arr[1]}`}`;
}


/**
 * 返回字符长度（中文2个字符）
 */
export const getStrLength = (value: string) => value.replace(/[^ -~]/g, 'AA').length

/**
 * 金额转中文（例如：12300000890）
 * @param   num    金额
 * 此方法是根据产品提供的网站(https://www.917118.com/tool/rmb.html)所转换的结果开发的。
 * 1-  金额的长度取余数，比如，长度11除以4余3
 * 2-  先截取余数，把123存入数组
 * 3-  截取余数后，再每4位截取，最终的数组为["123", "0000", "0890"]
 * 4-  0000不处理
 * 5-  最后一位是0（比如 0340），要在最后加”零“
 * 6-  当前数字和下一个数字都为0，不匹配中文和单位，否则当前为0的只匹配中文
 * 7-  由于bool，最终会出现”零零“的情况，比如 ["130", "0022"]这种情况
 * 8-  去掉最后一个零
 * 9-  finalStr如果为空（金额只有角、分的情况），直接赋值”零”
 * 10- 没有角分，加上”整“
 * 11- 00不处理
 * 12- 角分只取前两位
 * 13- 处理只有角、分的情况（比如0.45、0.7）
 */
export const dclToZh = (num: number | string) => {
  const numberCH = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  const unitSmall= ["", "拾", "佰", "仟"];
  const unitLarge = ["", "万", "亿"];
  const unitTiny = ["角", "分"];
  const unitBasic = "圆";
  const unitFinal = "整";
  const str: string = `${num}`;
  if (!str.trim() || str.substr(str.length - 1) === "." || isNaN(+str) || (+str) < 0 || (+str) > 999999999999.99) {
    return "";
  }

  const arr = str.replace(/,/g, "").split(".");
  let leftNum = arr[0];
  let finalStr = "";
  let len = leftNum.length;
  const first = len % 4;  // 1
  const leftArr = [];
  if (first) { // 2
    leftArr.push(leftNum.substring(0, first));
    leftNum = leftNum.substring(first);
    len = leftNum.length;
  }
  for (let i = 0; i < len; i = i + 4) { // 3
    leftArr.push(leftNum.substring(i, i + 4));
  }
  const mLen = leftArr.length;
  leftArr.forEach((ele: any, i: number) => {
    if (+ele) { // 4
      const eleLen = ele.length;
      const bool = ele.substring(ele.length - 1) === "0"; // 5
      for (let j = 0; j < eleLen; j++) { // 6
        finalStr += !+ele[j] && !+ele[j + 1] ? "" : `${ numberCH[ele[j]] }${ !+ele[j] ? "" : unitSmall[(eleLen - (j + 1))] }`;
      }
      finalStr += unitLarge[mLen - (i + 1)];
      finalStr += (bool ? "零" : "");
    }
  });
  finalStr = finalStr.replace(/零零/g, "零"); // 7
  if (finalStr.substring(finalStr.length - 1) === "零") { // 8
    finalStr = finalStr.substring(0, finalStr.length - 1);
  }
  finalStr = (finalStr || "零") + unitBasic; // 9
  if (!arr[1]) { // 10
    return finalStr += unitFinal;
  }
  const rightNum:any = arr[1];
  const rightLen = rightNum.length;
  let rightStr = "";
  if (+rightNum) { // 11
    for (let i = 0; i < rightLen; i++) {
      rightStr += `${numberCH[rightNum[i]]}${!+rightNum[i] ? "" : unitTiny[i]}`;
      if (i === 1) { // 12
        break;
      }
    }
  }
  finalStr += rightStr.replace(/角零/g, "角");
  if (finalStr.length > 2 && finalStr !== "零圆整" && finalStr.substr(0, 2) === "零圆") { // 13
    finalStr = finalStr.substr(2);
  }
  return finalStr;
}
